import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { axiosHandler } from "../lib/utils";

const key = "players";
export const PLAYERS_URL = "user/players?pending=1";

export const useGetPlayers = () => {
  const state = useSelector((state) => state);

  const query = useQuery({
    queryKey: [key],
    queryFn: () =>
      // R35: the web agent list also shows its own pending client requests (marked, no account data).
      axiosHandler({ url: PLAYERS_URL, state }).then((res) => {
        return res.data || [];
      }),
  });

  return query;
};

export const useGetAgentPlayers = ({ enabled = true }) => {
  const state = useSelector((state) => state);

  const query = useQuery({
    queryKey: [key, "agent"],
    enabled,
    queryFn: () =>
      axiosHandler({ url: "user/agent", state }).then((res) => {
        const data = res.data || [];
        return data.reduce((acc, client) => {
          acc[client.playerId] = client;
          return acc;
        }, {});
      }),
  });

  return query;
};

export const useAgentAddPlayer = ({ onSuccess, onError }) => {
  const state = useSelector((state) => state);

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data) =>
      axiosHandler({
        method: "POST",
        url: "user/agent/add",
        data,
        state,
      }).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries(key);
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export const useAgentDeletePlayer = ({ onSuccess, onError }) => {
  const state = useSelector((state) => state);

  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (data) => {
      return await axiosHandler({
        method: "POST",
        url: "user/agent/delete",
        data,
        state,
      }).then((res) => res.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries([key]);
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};
